<h3 class="ui primary header">
	{{ modal.context.title }}
	<i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
	<div class="ui basic vertical segment bank-details">
		<div>
			<h2 class="ui sub header">TRANSACTION ID</h2>
			<span>{{ data?.gatewayTransactionRefId || data?.transactionId }}</span>
		</div>
		<div>
			<h2 class="ui sub header">DESCRIPTION</h2>
			<span>{{ data?.description || "eWallet Withdrawal" }}</span>
		</div>
		<div>
			<h2 class="ui sub header">TYPE</h2>
			<span>{{
				(data?.description ? "Funding" : "Withdrawal") | titlecase
			}}</span>
		</div>
		<div>
			<h2 class="ui sub header">AMOUNT</h2>
			<span
				>{{ data?.currencyId == "naira" ? "₦" : "$"
				}}{{ data?.totalAmount || data?.amount | number: "1.2-2" }}</span
			>
		</div>
		<div>
			<h2 class="ui sub header">CHARGES</h2>
			<span
				>{{ data?.currencyId == "naira" ? "₦" : "$"
				}}{{ data?.totalCharges || 0 | number: "1.2-2" }}</span
			>
		</div>
		<div>
			<h2 class="ui sub header">TRANSACTION DATE</h2>
			<span>{{ data?.dateCreated | date: "medium" }}</span>
		</div>
		<div>
			<h2 class="ui sub header">STATUS</h2>
			<span class="ui yellow circular label">PENDING</span>
		</div>
	</div>

	<div class="actions" style="border: none">
		<button class="ui basic primary button" (click)="modal.deny(undefined)">
			Back
		</button>
	</div>
</div>
